import { render, staticRenderFns } from "./AdminCard.vue?vue&type=template&id=61e3980c&scoped=true&"
import script from "./AdminCard.vue?vue&type=script&lang=ts&"
export * from "./AdminCard.vue?vue&type=script&lang=ts&"
import style0 from "./AdminCard.vue?vue&type=style&index=0&id=61e3980c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61e3980c",
  null
  
)

export default component.exports